'use strict';

const platformUtils = require('santa-platform-utils');
const workerUtils = require('./workerUtils');
const events = require('../events');
const MessageType = require('./MessageType');
const wixCodeMessageType = require('../wixCodeMessageTypes');
const pmrpc = require('pm-rpc');

function createRemoteModelInterface(context, apps) {
  var RMI = new platformUtils.RemoteModelInterface(context);
  apps.forEach(function(app) {
    Object.keys(app.controllers).forEach(function(controllerId) {
      RMI.setPublicAPI(controllerId, app.controllers[controllerId].exports);
    });
  });

  return RMI;
}

function initSdk(messageData, RMI) {
  self.wix.__INTERNAL__.initModel({RMI: RMI, richTextUtils: platformUtils.richTextUtils, uriUtils: platformUtils.uriUtils, svgUtils: platformUtils.svgUtils, linkUtils: platformUtils.linkUtils, backgroundUtils: platformUtils.backgroundUtils, repeaterUtils: platformUtils.repeaterUtils, videoUrlsUtils: platformUtils.videoUrlsUtils, typeUtils: platformUtils.typeUtils, widgetUtils: platformUtils.widgetUtils, componentsHooks: platformUtils.componentsHooks}, messageData.siteInfo, messageData.id);
  self.$w = self.wix.getSelector(messageData.id);
  self.ga = self.wix.ga;
}

function exposePublicAPI({module: appModule = {}, appDefId} = {}, workerId) {
  if (appModule.exports) {
    pmrpc.api.set(`${MessageType.PLATFORM_PUBLIC_API_PREFIX}${appDefId}_${workerId}`, appModule.exports);
    workerUtils.sendMessage({
      type: MessageType.REQUEST_API,
      intent: wixCodeMessageType.WIX_CODE_INTENT,
      appDefId,
      workerId
    });
  }
}

function handleStart(messageData, {workerId, getAllApps}) {
  if (!messageData.id) {
    throw new Error('Could not init sdk: `context.id` is missing');
  }
  if (!messageData.context) {
    throw new Error('Could not init sdk: `context.context` is missing');
  }

  var beforePageReady = Date.now();
  const allApps = getAllApps();
  allApps.forEach(app => exposePublicAPI(app, workerId));
  var allReady = allApps.map(function(app) {
    var beforeStart = Date.now();
    app.controllersReady = app.controllersReady && app.controllersReady.then(function() {
      workerUtils.reportBI(events.APP_PAGE_READY, {
        app_id: app.id,
        worker_id: workerId,
        time_spent: Date.now() - beforeStart
      });
      return Promise.resolve();
    });
    return Promise.resolve(app.controllersReady);
  });

  return Promise.all(allReady)
    .then(function() {
      workerUtils.reportBI(events.ALL_APPS_PAGE_READY, {
        worker_id: workerId,
        time_spent: Date.now() - beforePageReady
      });
      var RMI = createRemoteModelInterface(messageData.context, getAllApps());
      initSdk(messageData, RMI);
      self.wix.__INTERNAL__.triggerOnReady(function() {
        workerUtils.sendMessage({
          intent: 'WIX_CODE',
          type: 'widget_ready',
          widgetId: messageData.id
        });
      });
    });
}

module.exports = {
  handleStart: handleStart
};



// WEBPACK FOOTER //
// ./src/main/worker/startHandler.js